import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    rowData: []
}

export const OpenentrySlice = createSlice({
    name: 'Openentry',
    initialState,
    reducers: {
        setRowData: (state, action) => {
            state.rowData = action.payload;
        }
    }
})

export const {
    setRowData
} = OpenentrySlice.actions

export default OpenentrySlice.reducer